<template>
	<panel-base :checked="data!==null" :ok="data===0" :loading="loading" @start="start" @stop="stop">
		<template #heading>
			Негативно показание
			<span v-if="data!==null">
				({{ data }})
			</span>
		</template>
		<template #content v-if="data!==null">
			<neg-dif-list
				:session="session"
				:imodel="imodel"
				:utility="utility"
			></neg-dif-list>
		</template>
	</panel-base>
</template>
<script>
import expansionPanelShort from "@/ittijs/ExpansionPanelShort";
import PanelBase from "@/views/report/checks/panelBase";
import NegDifList from "@/views/report/checks/components/negValList";
import checkMixin from "@/views/report/checks/checkMixin";

export default {
	components: {NegDifList, PanelBase},
	mixins: [
		expansionPanelShort,
		checkMixin(
			(self, getController) => self.imodel.negVal(self.session, getController)
		),
	],
	props: [
		'utility',
		'session',
		'imodel',
	],
	watch: {
		utility(){ this.reset() },
		session(){ this.reset() },
	},
}
</script>